import React from "react";

import "./ButtonIcon.css";
import IconLibrary from "../iconLibrary";

const ButtonIcon = ({ title, type, iconName, className, onClick, disabled, marginTop, color, spin, style, enviarEventoEnClick }) => {
    function handleClick(event) {
        if (!disabled && onClick != null) {
            onClick(enviarEventoEnClick === true ? event : null);
        }
    }

    return (
        <button
            title={title}
            style={{ marginTop: marginTop, color: color, ...style }}
            type={type == null ? "button" : type}
            className={`button-icon ${iconName} ${className ?? ""} ${type ?? ""} ${disabled ? "disabled" : ""} ${
                spin ? "fa-spin" : ""
            }`}
            onClick={handleClick}
        >
            <IconLibrary iconName={iconName} />
        </button>
    );
};

export default ButtonIcon;
